export enum Apps {
  CxCash = 'WebCash'
}
